<template>
  <div class="tabs__container">
    <div
      class="tabs__wrapper"
      :style="{
        height: `${height}px`,
      }"
    >
      <div
        v-for="(item, i) in Object.values(tabs)"
        :key="item"
        class="tab"
        :class="{ 'tab--active': tab === i }"
        @click="$emit('update:tab', i)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    tab: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      default: 28,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.tabs__container {
  font-size: 12px;
  line-height: 14px;

  .tabs__wrapper {
    position: relative;
    -webkit-box-shadow: 0px 0px 0px 1px $colorRed inset;
    -moz-box-shadow: 0px 0px 0px 1px $colorRed inset;
    box-shadow: 0px 0px 0px 1px $colorRed inset;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;

    .tab {
      color: $colorRed;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      flex: 1;

      &--active {
        background-color: $colorRed;
        color: $colorWhite;
      }
    }
  }
}
</style>
